import { render } from "./go.vue?vue&type=template&id=32bc8beb"
import script from "./go.vue?vue&type=script&lang=js"
export * from "./go.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__